jQuery(document).ready(function(){

  loadMoreProjects.init();
  // utility.init();

  // Mobile Menu

  jQuery('#mobile-menu').click(function(){

		jQuery('header').toggleClass('mobile-active');

		if(jQuery('header').hasClass('mobile-active')) {
			jQuery('body, html').css('overflow-y', 'hidden');
		} else {
			jQuery('body, html').css('overflow-y', 'auto');
		}
	});


  jQuery('.menu-item-has-children').click(function() {
		jQuery(this).toggleClass('active');
	});

  // Accordion

  jQuery(".accordion-title").click(function () {
    var _this = jQuery(this);

    _this.toggleClass("active");
    _this.siblings(".dropdown-content").toggleClass("active");
  });
});


jQuery(document).ready(function(){
  jQuery('.slider').each(function() {
    jQuery(this).flickity({
        autoPlay: 5000,
        prevNextButtons: false,
        imagesLoaded: true,
        pageDots: false,
        setGallerySize: true,
        wrapAround: jQuery(this).children().length > 3 ? true : false,
        draggable: true,
        cellAlign: 'left',
        contain: true
    });
  })

    jQuery('.carousel-main').flickity({
      autoPlay: 8000,
      prevNextButtons: true,
      imagesLoaded: true,
      pageDots: false,
      setGallerySize: true,
      wrapAround: true,
      draggable: false
    });

    jQuery('.carousel-nav').flickity({
      asNavFor: '.carousel-main',
      contain: true,
      prevNextButtons: false,
      pageDots: false
    });

    jQuery('.slider').addClass('active');
});

// Load More Posts


var loadMoreProjects = {
  init: function() {
    jQuery('#load-more').click(function(){
      loadMoreProjects.loadMore();
    });
  },

  loadMore: function() {
    var loadContainer = jQuery('#load-container');
    var postCount = jQuery('#load-container .project-thumbnail').length;
    var totalPosts = loadContainer.data('total');

    if(postCount >= totalPosts) {
      return;
    }

    var data = {
      action: 'load_more_projects',
      post_count: postCount,
      post_search: posts.s,
      current_taxonomy: posts.current_taxonomy,
      current_term: posts.current_term,
      current_child_term: posts.current_child_term,
    };

    jQuery.ajax({
      url: posts.ajaxurl,
      type: "POST",
      data: data,
      beforeSend: function () {

        // Request for posts
        jQuery('#load-more').addClass('loading');
      },

        complete: function () {

          // Request for posts received / response is being sent back to us
          jQuery('#load-more').removeClass('loading');
        },

        success: function(data) {

          // We get posts back / successful response
          if(data) {
            loadContainer.append(data);
          }

          postCount = jQuery('#load-container .project-thumbnail').length;

          if(postCount >= totalPosts) {
              jQuery('#load-more').replaceWith('<a class="no-posts button" href="#load-container">Back to top</a>');
          }

          utility.hashAnimate();

          return;
        }
    });
  }
}

// var utility = {
//     init: function() {
//       utility.hashAnimate();
//     },
//
//     hashAnimate: function() {
//         jQuery("*[href*=#]").click(function(e) {
//             e.preventDefault();
//
//             var localHash = jQuery(this).attr('href');
//             var scrollOffset = jQuery('header').outerHeight();
//
//             jQuery("html, body").animate({
//                 scrollTop: jQuery(localHash).offset().top - scrollOffset - 80
//             }, 200);
//         });
//     }
// }


// 2nd carousel, navigation
